import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: {},
  status: 'idle',
}

export const overviewFilters = createSlice({
  name: 'overviewFilters',
  initialState,

  reducers: {
    setFilters: (state, action) => {
        state.value = action.payload;
    },
  },
});

export const { setFilters } = overviewFilters.actions;

export const overviewFiltersList = (state) => state.overviewFilters.value;

export default overviewFilters.reducer;